import color from './color.helper'
import text from './text.helper'
import button from './button.helper'
import object from './object.helper'
import toast from "./toast.helper"
import link from "./link.helper"
import imageCrop from "./imageCrop.helper"
import component from "./component.helper"
import facebook from "./facebookSDK.helper"
import currency from "./currency.helper"
import data from "./data.helper"
import url from './url.helper'
import css from './css.helper'
import numeric from './numeric.helper'

const helperPlugin = {
  install: (Vue) => {
    Vue.prototype.$helper = {
      color,
      text,
      button,
      object,
      toast,
      imageCrop,
      component,
      facebook,
      currency,
      data,
      url,
      css,
      numeric,
    }
    Vue.prototype.$link = link
  }
}
export default helperPlugin